export enum ChartColorType {
    Default,
    Resultados
}
